module.exports = __webpack_public_path__ + "static/media/honeyCombBees.3021ca5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/honeyCombBees.jpg
// module id = 252
// module chunks = 0